<template>
  <div class="button-component">
    <md-button
      v-if="!hideButton"
      :disabled="buttonsDisabled"
      :class="'btn-' + size"
      :color="'btn-' + color"
      class="btn btn-nonenary"
      @click="emitFunction()"
    >
      <slot />
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    buttonsDisabled: {
      default: false,
      type: Boolean
    },
    size: {
      default: 'medium',
      type: String
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    color: {
      default: 'primary'
    }
  },
  methods: {
    emitFunction () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.button-component {
  
}
</style>
